<template>
    <div ref="file_upload" class="row m-b-sm">
        <div class="col-lg-12">
            <div class="float-e-margins">
                <div class="file-manager">
                    <form :id="'dropzone-' + id" class="dropzone-box widgets-dropzone-scrollbox">
                        <div class="dz-default dz-message"><span>{{ t_drop_upload }}</span></div>
                    </form>
                    <div class="upload-warning"
                         @mouseover="warningHover = true"
                         @mouseleave="warningHover = false">
                        <div v-if="warningHover"
                             class="alert alert-warning text-center">
                            {{ t_waiting }}
                        </div>
                        <i :class="fileReference > 0 ? 'text-warning' : ''"
                           class="fa-solid fa-triangle-exclamation"
                           aria-hidden="true"></i>
                    </div>
                    <div class="upload-info"
                         @mouseover="infoHover = true"
                         @mouseleave="infoHover = false">
                        <div v-if="infoHover"
                             class="alert alert-info">
                            <file-type-name-limit-list :allowed-file-types="['.ftt']" />
                        </div>
                        <i class="fa-solid fa-circle-info"
                           aria-hidden="true"></i>
                    </div>

                    <v-btn class="btn btn-primary btn-block widgets-fileinput-button m-t-sm">{{ t_upload }}</v-btn>
                </div>
            </div>
        </div>
        <div class="table widgets-dropzone-preview table-striped files hidden" id="widgets-preview">
            <div id="template" class="file-row">
                <div>
                    <strong class="error text-danger" data-dz-errormessage></strong>
                </div>
                <div class="progress widgets-dropzone-progress progress-striped active">
                    <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="0" role="progressbar" class="progress-bar"
                         data-dz-uploadprogress>
                        <p class="name widgets-dropzone-filename widgets-wrap-text" data-dz-name></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FileTypeNameLimitList from '../../../content/common/alert/file-type-name-limit-list.vue'
    import Dropzone from "@deltablot/dropzone";

    export default {
        components: { FileTypeNameLimitList },
        props: [
            'id',
            'global'
        ],
        data: function () {
            return {
                t_upload: Lang.langGet("Upload Files"),
                t_drop_upload: Lang.langGet("Drop files here to upload"),
                t_unknown: Lang.langGet("Unknown"),
                t_invalid: Lang.langGet("You can't upload files of this type."),
                t_waiting: Lang.langGet("Depending on file size it may take some minutes to process the upload."),
                fileReference: 0,
                dropzoneObject: null,
                infoHover: false,
                warningHover: false,
            }
        },
        watch: {
            fileReference(newValue) {
                this.filesToUpload(newValue);
            },
            global () {
                this.dropzoneObject.options.url = this.global === 1 ? '/administration/widget/upload-global' : '/administration/widget/upload';
            }
        },
        methods: {
            t_filename_limitation: function (matches) {
                return Lang.langGet("File name contains illegal symbols: ' :matches '", {matches: matches});
            },
            reset: function () {
                this.init();
            },
            increaseFileReference: function () {
                this.fileReference += 1;

                if (this.fileReference > 0) {
                    $('#dropzone-' + this.id + ' .dz-message').addClass('hidden');
                }
            },
            dereaseFileReference: function () {
                this.fileReference -= 1;

                if (this.fileReference <= 0) {
                    $('#dropzone-' + this.id + ' .dz-message').removeClass('hidden');
                }
            },
            init: function () {
                this.dropzoneObject = new Dropzone('#dropzone-' + this.id, {
                    url: this.global === '1' ? '/administration/widget/upload-global' : '/administration/widget/upload',
                    paramName: 'file',
                    timeout: 300000,
                    parallelUploads: 1,
                    chunking: true,
                    maxFilesize: Laravel.upload_max_filesize,
                    previewTemplate: document.getElementById('widgets-preview').innerHTML,
                    acceptedFiles: ['.ftt'].join(','),
                    dictInvalidFileType: this.t_invalid,
                    headers: {
                        'X-CSRF-TOKEN': Laravel.csrfToken
                    },
                    dictDefaultMessage: Lang.langGet("Drop files here to upload"),
                    clickable: '.widgets-fileinput-button',
                    'error': function (file, response) {
                        if(file.previewElement) {
                            let message = $(file.previewElement).find('.widgets-dropzone-filename').html();
                            message = message + ': ' + response;
                            $(file.previewElement).find('.widgets-dropzone-filename').html(message);
                            $(file.previewElement).find('[role=progressbar]').css('width', '100%');
                        }
                    },
                    'chunksUploaded': function (file, done) {
                        if(file.previewElement) {
                            file.previewElement.querySelector('.dz-processing .progress.active .progress-bar').style.width = '100%';
                        }
                        done();
                    },
                    'addedfiles': (files) => {
                        this.$emit("addedFiles");
                    },
                    'uploadprogress': function (file, progress, bytesSent) {
                        if(file.previewElement) {
                            file.previewElement.querySelector('.progress.active .progress-bar').style.width = progress + '%';
                        }
                    },
                    'complete': (file) => {
                        let timeout = 0;

                        if (file.status === 'error') {
                            timeout = 10000;
                        }

                        setTimeout(() => {
                            this.dropzoneObject.removeFile(file);
                            this.dereaseFileReference();
                        }, timeout);
                    },
                    'success': (data) => {
                        const json = this.getJson(data);

                        if (typeof json.data === 'string') {
                            let message = $(data.previewElement).find('.widgets-dropzone-filename').html();
                            message = message + ': ' + this.t_unknown + ': ' + json.data;
                            $(data.previewElement).find('.widgets-dropzone-filename').html(message);
                            data.status = 'error';
                        } else {
                            this.handleUpload(JSON.stringify(json));
                        }
                    },
                    'accept': (file, done) => {
                        let filename = file.name.replace(/\.[^/.]+$/, '');
                        let pregex = /^[\x5F]/;
                        let regex = RegExp('[\x22\x2A\x2F\x3A\x3C\x3E\x3F\x5C\x7C]', 'g');
                        let uregex = regex;
                        if(Laravel.filenameRegex) {
                            uregex = RegExp(Laravel.filenameRegex, 'g');
                        }
                        let matchstring = '';
                        const match = RegExp.prototype[Symbol.match].call(pregex, filename);
                        const matches = RegExp.prototype[Symbol.matchAll].call(regex, filename);
                        const result = RegExp.prototype[Symbol.matchAll].call(uregex, filename);
                        if(match) matchstring += '_';
                        if(matches) matchstring += Array.from(matches).join(', ');
                        if(result) matchstring +=  Array.from(result).join(', ');

                        if (pregex.test(filename) || regex.test(filename) || uregex.test(filename)) {
                            done(this.t_filename_limitation(matchstring));
                        } else {
                            done();
                        }
                    }
                });

                this.dropzoneObject.on('addedfile', (file) => {
                    this.increaseFileReference();
                });

            },
            'cancelUpload': function () {
                this.dropzoneObject.removeAllFiles(true);
            },
            handleUpload: function (data) {
                let json = jQuery.parseJSON(data);
                if(json.data.element) {
                    this.$emit('uploadedFile', json.data.element);
                } else if (json.data.error) {
                    this.$emit('uploadFailed', json.data.error);
                } else if (json.data.information) {
                    this.$emit('actionNeeded', json.data.information);
                }
            },
            filesToUpload: function (count) {
                this.$emit('filesToUpload', count);
            },
            getJson(data) {
                const response = data.xhr.responseText;
                if (response.charAt(0) === '{') return JSON.parse(response);

                const jsonStartsAt = response.search('{');
                const json = response.slice(jsonStartsAt);
                return JSON.parse(json);
            }
        },
        mounted() {
            this.init();

            EaseEventBus.listen('cancelUpload', () => {
                this.cancelUpload();
            });
        },
    }
</script>
